/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pos_Lot_Has_ErrorInputs */

const vi_pos_lot_has_error = /** @type {(inputs: Pos_Lot_Has_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phân bổ lô chưa khớp số lượng — kiểm tra lại trước khi bán.`)
};

/**

* @param {Pos_Lot_Has_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pos_lot_has_error = /** @type {((inputs?: Pos_Lot_Has_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pos_Lot_Has_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pos_lot_has_error(inputs)
});